import React from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';

import PropTypes from 'prop-types';
import LevelItem from './LevelItem';

class LevelList extends React.Component {
    render() {
        const { changeLevelList, levelList, moveLevel, disabledActions } = this.props;

        return levelList.map((level, indexLevel) => {
                return (
                    <LevelItem
                        key={level.id}
                        changeLevelList={changeLevelList}
                        levelList={levelList}
                        level={level}
                        indexLevel={indexLevel}
                        moveLevel={moveLevel}
                        disabledActions={disabledActions}
                    />)
            })
    }
}

LevelList.propTypes = {
    changeLevelList: PropTypes.func,
    levelList: PropTypes.array,
    moveLevel: PropTypes.func,
    disabledActions: PropTypes.bool,
};

export default DragDropContext(HTML5Backend)(LevelList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/LevelList.jsx